/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var People1BadgeIcon16Solid = forwardRef('People1BadgeIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8 8a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 9c-1.805 0-5.294.3-5.907 4.603C1.984 14.368 2.627 15 3.4 15h9.2c.773 0 1.416-.632 1.307-1.397C13.294 9.3 9.805 9 8 9Zm-.75 3.25A.75.75 0 0 1 8 11.5h2.75a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75Z" })));
});
